import React, {useState} from 'react';
import {animated, useSpring} from '@react-spring/web';

export const AnimCorrect = ({
    visible,
    duration = 50,
}: {
    visible: boolean;
    duration?: number;
}) => {
    const [length] = useState(100);
    const animatedStyle = useSpring({
        config: {duration},
        strokeDasharray: length,
        strokeDashoffset: visible ? 0 : length,
    });

    return (
        <div>
            <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 130.2 130.2">
                <animated.polyline
                    style={animatedStyle}
                    className="path check"
                    fill="none"
                    stroke="#059669"
                    strokeWidth="6"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    // points="100.2,40.2 51.5,88.8 29.8,67.5"
                    points="28.8,67.5 51.5,88.8 100.2,40.2"
                    {...({} as any)} // Type assertion
                />
            </svg>
        </div>
    );
};
